module.exports = __webpack_public_path__ + "gw.f13d4957d1ec4ccccca3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gw.svg
// module chunks = styles